import { useEffect, useRef } from 'react';
import { includes } from 'lodash';

export const useSetUpLocations = ({ rideDetails, addMissingLocations, locations }) => {
  // on page load, we only fetch the first 10 locations
  // if a waypoint's location is not in the first 10, we need to fetch the data
  const fetchOnce = useRef(false);

  useEffect(() => {
    if (!fetchOnce.current && rideDetails?.waypoints.length && locations.length) {
      const allLocationIds = locations.map((loc) => String(loc.id));
      const missingLocations = rideDetails?.waypoints.reduce((matches, waypoint) => {
        if (!includes(allLocationIds, String(waypoint.location.id))) {
          return [...matches, waypoint.location.id];
        }

        return matches;
      }, []);

      addMissingLocations(missingLocations);
      fetchOnce.current = true;
    }
  }, [rideDetails, locations]);

  return { isFetching: !fetchOnce.current };
};
